import React from 'react';
import { useFormik } from "formik";
import { get, uniq } from 'lodash';
import { Grid2 } from "@mui/material";
import TableCell from "./TableCell";
import CompanyRowsContainer from "../CompanyRowsContainer";
import InvisibleSelect from "../InvisibleSelect";

import classes from './index.module.scss';

const STATUS_KEY = 'lastRecord.status';
const TYPE_KEY = 'product_type.productTypeName';
const CLASSIFICATION_KEY = 'classification.classification';

function extractValues(companyList = [], fieldKey) {
  const result = [];

  companyList.forEach((company) => {
    (company.productList || []).forEach((product) => {
      const value = get(product, fieldKey);

      if (value) {
        result.push(value);
      }
    })
  });

  result.sort();

  return uniq(result);
}

function makeFilter(companyList = [], status, type, classification) {
  if (!status && !type && !classification) {
    return companyList;
  }

  const result = [];

  companyList.forEach((company) => {
    const productList = [];

    (company.productList || []).forEach((product) => {
      const currentStatus = get(product, STATUS_KEY);
      const currentType = get(product, TYPE_KEY);
      const currentClassification = get(product, CLASSIFICATION_KEY);

      if (
        (!status || currentStatus === status) &&
        (!type || currentType === type) &&
        (!classification || currentClassification === classification)
      ) {
        productList.push(product);
      }
    })

    if (productList.length > 0) {
      result.push({
        ...company,
        productList,
      })
    }
  });

  return result;
}

const CertificateTable = (props) => {
  const {
    isApproved,
    companyList,
    searchInput,
    rightButton,
    showCompanyRow = true,
    showCompanyLink = false,
    isPremium = false,
  } = props;

  const initialValues = {
    status: '',
    type: '',
    classification: '',
  }

  const filterFormik = useFormik({
    initialValues,
    onSubmit: () => {},
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
  });

  const { status, type, classification } = filterFormik.values;
  const statusItems = extractValues(companyList, STATUS_KEY);
  const typeItems = extractValues(companyList, TYPE_KEY);
  const classificationItems = extractValues(companyList, CLASSIFICATION_KEY);

  const filteredCompanyList = makeFilter(companyList, statusItems[status], typeItems[type], classificationItems[classification]);

  return (
    <Grid2 container className={classes.certificateTable} size={12}>
      <Grid2 container size={12}>
        <TableCell size={12} clearBorderBottom center fullWidth>
          <Grid2 container>
            <Grid2 size={rightButton ? 10 : 12}>
              {
                searchInput
              }
            </Grid2>
            {
              rightButton ? (
                <Grid2 size={2}>
                  {
                    rightButton
                  }
                </Grid2>
              ) : null
            }
          </Grid2>
        </TableCell>
        <Grid2 container direction='row' size={12}>
          <Grid2 container direction='row' size={4} className={classes.fullHeight}>
            <TableCell size={12} caption clearBorderRight clearBorderBottom center className={classes.halfHeight}>
              Certificate
            </TableCell>
            <Grid2 container direction="row" size={12} className={classes.halfHeight}>
              <TableCell caption center size={3} clearBorderRight clearBorderBottom>Number</TableCell>
              <TableCell caption center size={3} clearBorderRight clearBorderBottom>Date</TableCell>
              <TableCell caption center size={3} clearBorderRight clearBorderBottom clearPadding fullWidth>
                <InvisibleSelect
                  name='status'
                  label='Status'
                  value={status}
                  onChange={filterFormik.handleChange}
                  itemList={statusItems}
                />
              </TableCell>
              <TableCell caption center size={3} clearBorderRight clearBorderBottom>Files</TableCell>
            </Grid2>
          </Grid2>
          <Grid2 container size={isPremium ? 6 : 7} direction='column' className={classes.fullHeight}>
            <TableCell size={12} caption clearBorderBottom clearBorderRight center className={classes.halfHeight}>
              Product
            </TableCell>
            <Grid2 container direction='row' size={12} className={classes.halfHeight}>
              <TableCell caption size={2} clearBorderRight center clearBorderBottom clearPadding fullWidth>
                <InvisibleSelect
                  name='type'
                  label='Type'
                  value={type}
                  onChange={filterFormik.handleChange}
                  itemList={typeItems}
                />
              </TableCell>
              <TableCell caption size={5} clearBorderRight center clearBorderBottom>Name</TableCell>
              <TableCell caption size={5} clearBorderRight center clearBorderBottom>Part-no. of DUT</TableCell>
            </Grid2>
          </Grid2>
          {
            isPremium ? (
              <TableCell size={1} caption center fullHeight clearBorderRight clearBorderBottom>
                Test plan
              </TableCell>
            ) : null
          }
          <TableCell size={1} caption center fullHeight clearBorderBottom clearPadding fullWidth>
            <InvisibleSelect
              name='classification'
              label='Classification'
              value={classification}
              onChange={filterFormik.handleChange}
              itemList={classificationItems}
            />
          </TableCell>
        </Grid2>
      </Grid2>
      <Grid2 container size={12}>
        {
          filteredCompanyList.map((company) => (
            <CompanyRowsContainer
              showCompanyRow={showCompanyRow}
              key={company.name}
              company={company}
              showCompanyLink={showCompanyLink}
              isApproved={isApproved}
              isPremium={isPremium}
            />
          ))
        }
      </Grid2>
    </Grid2>
  )
}

export default CertificateTable;